import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { OperatorStatistic } from '@/models/statistic';

export const fetchOperatorsStatistics = async ({
  operatorId,
  startDate,
  endDate,
}: {
  operatorId: string;
  startDate: string;
  endDate: string;
}): Promise<OperatorStatistic | null> => {
  const response = await queryExecute({
    variables: {
      operatorId,
      startDate,
      endDate,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query OperatorsStatistics($operatorId: String!, $startDate: String!, $endDate: String!) {
        operatorsStatistics(operatorId: $operatorId, startDate: $startDate, endDate: $endDate) {
          callsCount
          more30SecsDurationCallsCount
          avgHandleTimeMins
        }
      }
    `),
  });

  return response.data.operatorsStatistics ?? null;
};
